import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import App from './App';

// Create a theme inspired by Yu-Gi-Oh! card design
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#b08d57', // Lighter metallic gold for dark mode
      light: '#d4b485',
      dark: '#8b6d3c',
      contrastText: '#000',
    },
    secondary: {
      main: '#a06668', // Lighter burgundy for dark mode
      light: '#c48f91',
      dark: '#7c4c4e',
      contrastText: '#000',
    },
    background: {
      default: '#1c1c1c', // Dark background
      paper: '#2c2c2c', // Slightly lighter dark
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0b0b0',
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
      color: '#b08d57', // Lighter gold for dark mode
    },
    h5: {
      color: '#a06668', // Lighter burgundy for dark mode
      fontWeight: 500,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        outlined: {
          borderColor: 'rgba(176, 141, 87, 0.3)', // Transparent gold
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&.MuiChip-colorPrimary': {
            backgroundColor: '#b08d57',
            color: '#000',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          borderColor: 'rgba(176, 141, 87, 0.3)',
          color: '#b08d57',
          '&:hover': {
            borderColor: '#b08d57',
            backgroundColor: 'rgba(176, 141, 87, 0.08)',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(176, 141, 87, 0.3)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#b08d57',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#b08d57',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#b0b0b0',
          '&.Mui-focused': {
            color: '#b08d57',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: '#b0b0b0',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
